import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Icon } from '../Icon/index.js';
import { useAlertContext, statuses } from './Alert.js';

const getIconColor = status => statuses[status] ? `${statuses[status].color}500` : 'carbon900';
const getIconName = status => statuses[status] ? statuses[status].icon : 'Information';
/**
 * Alerts are used to communicate a state that affects a system, feature or page.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/alert#usage)
 * - [Props](https://blockparty.endpoint.com/components/alert#props)
 * <br />
 *
 */
const AlertIcon = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    ...props
  } = _ref;
  const {
    status
  } = useAlertContext();
  const iconColor = getIconColor(status);
  const iconName = getIconName(status);
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    ref: forwardedRef,
    color: iconColor,
    mr: "space50",
    name: iconName,
    size: "large"
  }, props));
});

export { AlertIcon, getIconColor, getIconName };
